var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1302 9.05817C10.0469 9.04984 9.94688 9.04984 9.85521 9.05817C7.87187 8.9915 6.29688 7.3665 6.29688 5.3665C6.29687 3.32484 7.94688 1.6665 9.99688 1.6665C12.0385 1.6665 13.6969 3.32484 13.6969 5.3665C13.6885 7.3665 12.1135 8.9915 10.1302 9.05817Z",
    stroke: "#2948A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.96563 12.1335C3.94896 13.4835 3.94896 15.6835 5.96563 17.0252C8.25729 18.5585 12.0156 18.5585 14.3073 17.0252C16.324 15.6752 16.324 13.4752 14.3073 12.1335C12.024 10.6085 8.26562 10.6085 5.96563 12.1335Z",
    stroke: "#2948A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.bd0ddb93e113426fcb1a621d3957c1a6.svg";
export { ForwardRef as ReactComponent };